<app-body-layout
  *ngIf="layoutReady"
  [navItems]="navItems"
  [showSidebar]="showSidebar"
  [logoUrl]="'assets/portallogo_lightmode.svg'"
  [logoBadge]="logoBadge"
  [logoutFunction]="this.logoutFn.bind(this)"
>
  <ng-container topbar-start>
    @if (!showSidebar && canManageCompany) {
    <a
      pButton
      [text]="true"
      routerLink="/verwaltung"
      routerLinkActive="header-link-active"
      class="text-decoration-none company-administration-link"
      ariaCurrentWhenActive="page"
      aria-label="Verwaltung"
      i18n-aria-label="@@companyAdministration"
      title="Verwaltung"
      i18n-title="@@companyAdministration"
    >
      <i
        class="ri-settings-3-line"
        aria-hidden="true"
      ></i><span i18n="@@companyAdministration">Verwaltung</span>
    </a>
    }
  </ng-container>
  <ng-container topbar-extra>
    @if (loginService.loggedInUser) {
    @if (contextItems.length > 1) {
    <button
      pButton
      type="button"
      severity="secondary"
      [text]="true"
      [disabled]="switchingMandant"
      [loading]="switchingMandant"
      class="context-button"
      aria-label="Mandant auswählen"
      (click)="contextMenu.toggle($event)"
    >
      <i
        class="ri-building-line"
        aria-hidden="true"
      ></i>
      <span class="context-name">{{ isAdminRoute ? adminAreaLabel : currentMandantName }}</span>
      @if (!isAdminRoute && logoBadge) {
      <span class="context-badge">{{ logoBadge }}</span>
      }
      <i
        class="ri-arrow-down-s-line"
        aria-hidden="true"
      ></i>
    </button>
    } @else if (mandants.length === 1) {
    <span class="context-name">{{ currentMandantName }}</span>
    @if (logoBadge) {
    <span class="context-badge">{{ logoBadge }}</span>
    }
    }
    <p-menu
      #contextMenu
      [model]="contextItems"
      [popup]="true"
      appendTo="body"
    />
    }
  </ng-container>
  <reflact-user-menu
    topbar-extra
    [authenticated]="!!loginService.loggedInUser"
    [busy]="switchingMandant || leavingMandant || refreshingAccount"
    [userName]="loginService.loggedInUser?.name || 'Profil'"
    [notifications]="logtoService.notificationOptions()"
    [feedback]="currentMandant ? feedbackOptions : undefined"
    [notificationIdentity]="(loginService.loggedInUser?._id?.toString() || '') + ':' + currentMandant"
    [mandants]="menuMandants"
    [showContext]="false"
    [accountUrl]="logtoService.accountUrl()"
    [canLeaveMandant]="true"
    (accountOpened)="accountOpened()"
    (mandantLeaveRequested)="leaveMandant($event)"
    [additionalContexts]="[]"
    [customProfile]="true"
    (profileRequested)="openSelfUserSettings()"
    (logoutRequested)="logoutFn()"
  ></reflact-user-menu>

  <router-outlet></router-outlet>
</app-body-layout>


<app-overlay-aside #selfUserSettings>
  <div
    header
    *ngIf="selfUserSettings.selectedObject"
  >
    <h1 i18n="@@globalProfile">Profil</h1>
  </div>
  <div *ngIf="selfUserSettings.selectedObject">
    <app-form
      [formFields]="formFields"
      [data]="selfUserSettings.selectedObject.data"
      [translatedLabels]="translatedLabels"
      (submit)="updateSelfUser($event);"
      [saving]="savingSelfUser"
      [hideDeleteButton]="true"
    ></app-form>

    <div class="mt-4 d-flex flex-column gap-2">
      <label
        for="profile-color-scheme"
        i18n="@@themeColorScheme"
      >Farbschema</label>
      <p-select
        inputId="profile-color-scheme"
        ariaLabel="Farbschema"
        i18n-ariaLabel="@@themeColorScheme"
        [options]="themeService.options"
        optionLabel="label"
        optionValue="value"
        [ngModel]="themeService.mode()"
        (ngModelChange)="themeService.setMode($event)"
        appendTo="body"
      ></p-select>
    </div>
  </div>
</app-overlay-aside>